import Vue, { VNode } from "vue";
import { ApiErrors, ApiException } from "../../services/volateq-api/api-errors";
import { Store, store } from "../../stores/store";
import { DiagnosticErrorRequest } from "../../services/volateq-api/api-requests/user-requests";
import { DateHelper } from "../../services/helper/date-helper";
import { BaseError } from "../../services/errors/base-error";

export abstract class BaseComponent extends Vue {
  public static diagnosticErrors: DiagnosticErrorRequest[] = [];
  public static hasDiagnosticEventAdded = false;

  protected setBrowserTitle(title?: string) {
    document.title = title ? title : "Volateq";
  }

  public get store(): Store {
    return store;
  }

  public get isMobile(): boolean {
    return this.store.mobile.isMobile;
  }

  public showError(e: any) {
    console.error(e);

    if (e instanceof BaseError) {
      BaseComponent.diagnosticErrors.push({
        error_id: e.errorId,
        message: e.message,
        app_url: window.location.href,
        timestamp: DateHelper.toDateTimeWithSeconds(DateHelper.now()),
      });
    }
    
    let toastContent: VNode | string;

    if (e.error) {
      const error: ApiException = e;

      toastContent = this.$createElement("p", {}, [
        error.error,
        this.$createElement("br"),
        error.message && this.$createElement("small", {}, error.message) || "",
      ]);
    } else if (e instanceof Error) {
      toastContent = this.$createElement("p", {}, e.toString());
    } else if (typeof e === "string") {
      toastContent = e;
    } else {
      toastContent = this.$createElement("p", {}, ApiErrors.SOMETHING_WENT_WRONG);
    }

    this.$bvToast.toast(" ", {
      title: toastContent,
      variant: "danger",
      bodyClass: "base-toast-body",
      headerClass: "base-toast-header",
      toaster: "b-toaster-bottom-center",
      solid: true,
      noAutoHide: true,
    });
  }

  public showSuccess(msg: string, autoHide = true) {
    this.$bvToast.toast(" ", {
      title: msg,
      variant: "success",
      bodyClass: "base-toast-body",
      headerClass: "base-toast-header",
      toaster: "b-toaster-bottom-center",
      solid: true,
      noAutoHide: !autoHide,
    });
  }

  public showInfo(msg: string, autoHide = true) {
    this.$bvToast.toast(" ", {
      title: msg,
      variant: "info",
      bodyClass: "base-toast-body",
      headerClass: "base-toast-header",
      toaster: "b-toaster-bottom-center",
      solid: true,
      noAutoHide: !autoHide,
    });
  }

  public showWarning(msg: string, autoHide = true) {
    this.$bvToast.toast(" ", {
      title: msg,
      variant: "warning",
      bodyClass: "base-toast-body",
      headerClass: "base-toast-header",
      toaster: "b-toaster-bottom-center",
      solid: true,
      noAutoHide: !autoHide,
    });
  }
}